module.exports = __webpack_public_path__ + "static/media/md-download.8e10a5c8.svg";